import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb308ca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "svg-map-wrap",
  id: "map-container",
  ref: "container"
}
const _hoisted_2 = { class: "state" }
const _hoisted_3 = ["d", "onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "separator",
  fill: "none",
  d: "m 215,493 v 55 l 36,45 m -251,-168 h 147 l 68,68 h 85 l 54,54 v 46"
}, null, -1))
const _hoisted_6 = { class: "mt-6 flex items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-base leading-6 font-semibold" }, "Nationwide", -1))
const _hoisted_8 = {
  key: 0,
  class: "mt-6 pr-6 flex items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-700 block mr-2" }, "Filter:", -1))
const _hoisted_10 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_11 = { class: "flex items-center justify-start mb-2" }
const _hoisted_12 = { class: "text-base leading-6 font-semibold" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "flex flex-wrap"
}
const _hoisted_17 = { class: "flex items-center h-5" }
const _hoisted_18 = ["id", "name", "onUpdate:modelValue", "value"]
const _hoisted_19 = { class: "ml-3 text-sm" }
const _hoisted_20 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_ChevronUpIcon = _resolveComponent("ChevronUpIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", {
        viewbox: "0 0 959 593",
        width: "959px",
        height: "593",
        style: _normalizeStyle({ 'transform': `scale(${_ctx.scale})` })
      }, [
        _createElementVNode("g", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, ([code, path, label], index) => {
            return (_openBlock(), _createElementBlock("path", {
              class: _normalizeClass(["state-single", {
            'is-active': _ctx.collectedData[code.toUpperCase()]?.selected.size == _ctx.collectedData[code.toUpperCase()]?.countiesAmount,
            'has-county': _ctx.collectedData[code.toUpperCase()]?.selected.size
          }]),
              d: path,
              key: index,
              onClick: ($event: any) => (_ctx.selectState(code.toUpperCase(), null))
            }, [
              _createElementVNode("title", null, _toDisplayString(label), 1)
            ], 10, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("g", {
          class: "borders",
          fill: "none",
          innerHTML: _ctx.borders.join()
        }, null, 8, _hoisted_4),
        _hoisted_5
      ], 4))
    ], 512),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_ctx.nationwide)
        ? (_openBlock(), _createBlock(_component_CheckCircleIcon, {
            key: 0,
            class: "text-green-500 ml-2 w-4 h-4"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "text-xs bg-gray-200 text-dark rounded-md cursor-pointer px-3 py-1 ml-2",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleNationwide && _ctx.handleNationwide(...args)))
      }, _toDisplayString(_ctx.nationwide ? 'Clear' : 'Select all'), 1)
    ]),
    (!_ctx.nationwide)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
            type: "text",
            placeholder: "State name / State code / County name / FIPS code",
            class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          }, null, 512), [
            [_vModelText, _ctx.searchQuery]
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.nationwide)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFootprints, ({ types, stateCode, description }) => {
            return (_openBlock(), _createElementBlock("div", {
              key: stateCode,
              class: "mb-6"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h4", _hoisted_12, _toDisplayString(description), 1),
                types
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["text-xs text-sky font-medium ml-4 flex items-center", { 'bg-yellow-100': !_ctx.collectedData[stateCode].isVisible && _ctx.searchQuery.length }]),
                        href: "#toggle",
                        onClick: _withModifiers(($event: any) => (_ctx.collectedData[stateCode].isVisible = !_ctx.collectedData[stateCode].isVisible), ["prevent"])
                      }, [
                        _createTextVNode(" Counties (" + _toDisplayString(_ctx.collectedData[stateCode].selected.size) + " / " + _toDisplayString(types ? types.length : 0) + ") ", 1),
                        (!_ctx.collectedData[stateCode].isVisible)
                          ? (_openBlock(), _createBlock(_component_ChevronDownIcon, {
                              key: 0,
                              class: "w-3 h-3 ml-1"
                            }))
                          : (_openBlock(), _createBlock(_component_ChevronUpIcon, {
                              key: 1,
                              class: "w-3 h-3 ml-1"
                            }))
                      ], 10, _hoisted_13),
                      _createElementVNode("button", {
                        class: _normalizeClass(["text-xs bg-gray-200 text-dark rounded-md cursor-pointer px-3 py-1 ml-2", { 'opacity-40 hover:opacity-100': _ctx.collectedData[stateCode].selected.size !== types.length }]),
                        type: "button",
                        onClick: ($event: any) => (_ctx.selectState(stateCode, types))
                      }, _toDisplayString(_ctx.collectedData[stateCode].selected.size == types.length ? 'Clear' : 'Select all'), 11, _hoisted_14)
                    ], 64))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "text-xs bg-gray-200 text-dark rounded-md cursor-pointer px-3 py-1 ml-2 opacity-40 hover:opacity-100",
                      type: "button",
                      onClick: ($event: any) => (_ctx.selectState(stateCode, types))
                    }, _toDisplayString(_ctx.collectedData[stateCode].selected.size ? 'Clear' : 'Select'), 9, _hoisted_15))
              ]),
              (types && _ctx.collectedData[stateCode].isVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types, ({ description: county, id }, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "relative flex items-start mt-2 w-1/2 lg:w-1/3",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            id: id,
                            name: stateCode,
                            type: "checkbox",
                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.collectedData[stateCode].selected) = $event),
                            value: id
                          }, null, 8, _hoisted_18), [
                            [_vModelCheckbox, _ctx.collectedData[stateCode].selected]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("label", {
                            for: id,
                            class: _normalizeClass(["font-medium text-gray-700 cursor-pointer", { 'bg-yellow-100': _ctx.shouldHighlight(id, county)}])
                          }, _toDisplayString(county || id), 11, _hoisted_20)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}